/*!
 * @Author: leo
 * @Date: 2019-12-31 11:30:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-31 11:30:00
 * @Instruduction: API HOST 全局配置
 */

const DEV_HOST = 'https://tpdapi.media.beer/'            // 开发环境接口域名
const API_PROD_HOST = 'https://paoding.waykey.net/'       // 正常环境接口域名
const API_NIUMEI_HOST = 'https://api.media.beer/'       // 牛媒网站接口域名
const IMG_HOST = 'https://images.media.beer/'           // 图片域名
const NIUMEI_HOST = 'https://media.beer/'               // 牛媒网域名
const NIUMEI_TEST_HOST = 'http://t.mediarank.cn/'       // 牛媒网测试域名

const PD_DEV_HOST = 'tpd.media.beer'                    // 庖丁测试环境域名（不带协议）
const PD_PROD_HOST = 'pd.media.beer'                    // 庖丁正式环境域名（不带协议）
const HOST_PREFIX = 'v1'
const HOST = (() => {
    // 优先使用构建时注入的测试/指定环境后端地址（如 VUE_APP_API_BASE_URL=http://<IP>:18483）
    // 不配置时回退到原有按域名区分的逻辑，保证正式/线上环境行为不变
    const injectedApiBase = process.env.VUE_APP_API_BASE_URL
    if (injectedApiBase) {
        return injectedApiBase.replace(/\/+$/, '') + '/'
    }
    const isProd = process.env.NODE_ENV === 'production'
    const isTpd = location.href.includes(PD_DEV_HOST)
    return isProd ? isTpd ? DEV_HOST : API_PROD_HOST : '/'
    // return DEV_HOST
})()

export {
    HOST, 
    API_PROD_HOST, 
    HOST_PREFIX, 
    IMG_HOST, 
    API_NIUMEI_HOST, 
    NIUMEI_HOST, 
    NIUMEI_TEST_HOST,
    PD_PROD_HOST,
    PD_DEV_HOST
}
